import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

const reviews = [
  {
    name: "Laura B.",
    project: "Ristrutturazione completa — 95 mq",
    text: "Casa consegnata puntuale e senza sorprese sul preventivo. Un unico referente per tutto il cantiere: non ho dovuto pensare a nulla, nemmeno alle pratiche.",
  },
  {
    name: "Marco T.",
    project: "Bagno padronale",
    text: "Squadra precisa e pulita: cantiere sempre in ordine e vicini di casa mai disturbati. Il bagno è esattamente come nel progetto, curato in ogni dettaglio.",
  },
  {
    name: "Giulia & Andrea",
    project: "Cucina e impianti",
    text: "Sopralluogo gratuito, preventivo chiaro voce per voce e lavori finiti prima del previsto. Li abbiamo già consigliati a due amici.",
  },
];

const Stars = () => (
  <div className="flex gap-1 mb-6" aria-label="5 stelle su 5">
    {Array.from({ length: 5 }).map((_, i) => (
      <Star key={i} className="w-4 h-4 text-gold fill-gold" strokeWidth={1} />
    ))}
  </div>
);

export const Reviews = () => (
  <section id="recensioni" className="py-28 lg:py-40 bg-surface border-y border-white/10 mt-16 lg:mt-24" data-testid="reviews-section">
    <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
        className="mb-20 lg:mb-28"
      >
        <p className="font-oswald text-gold uppercase tracking-[0.35em] text-sm mb-6">Dicono di noi</p>
        <h2 className="font-oswald uppercase text-3xl md:text-5xl tracking-[0.08em] leading-tight max-w-3xl" data-testid="reviews-title">
          Clienti soddisfatti, <span className="text-gold">chiavi consegnate</span>
        </h2>
      </motion.div>

      <div className="grid md:grid-cols-3 gap-8 lg:gap-12">
        {reviews.map((r, i) => (
          <motion.figure
            key={r.name}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: i * 0.12, ease: [0.76, 0, 0.24, 1] }}
            className="bg-ink border border-white/10 p-8 lg:p-10 flex flex-col"
            data-testid={`review-card-${i + 1}`}
          >
            <Quote className="w-8 h-8 text-white/10 mb-6" strokeWidth={1} />
            <Stars />
            <blockquote className="text-muted-foreground leading-loose text-base flex-1">{r.text}</blockquote>
            <figcaption className="mt-8 pt-6 border-t border-white/10">
              <span className="font-display text-lg block">{r.name}</span>
              <span className="font-oswald uppercase text-xs tracking-[0.25em] text-gold mt-2 block">{r.project}</span>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);
